import React, { useEffect, useState } from 'react';
import { useEffectAsync } from '../../helpers';
import apiClient from '../../Services/ApiClient';
import { useAppContext } from '../../Services/AppContext';

interface NotificationCountProps {
	isSpan?: boolean;
	classes: string;
}

const NotificationCount: React.FC<NotificationCountProps> = ({
	isSpan = false,
	classes,
}) => {
	// @ts-ignore
	const { socket } = useAppContext();
	const [count, setCount] = useState<number>(0);
	const [isLoading, setIsLoading] = useState(false);

	const handleLoadData = async () => {
		if (isLoading) {
			return;
		}

		setIsLoading(true);
		const {
			data: { meta },
		} = await apiClient.get('/notifications/?unread=1');
		setCount(meta?.count || 0);
		setIsLoading(false);
	};

	const handleMessageReceived = async (data: any) => {
		if (data.type === 'notification') {
			await handleLoadData();
		}
	};

	useEffect(() => {
		// @ts-ignore
		socket.on('message', handleMessageReceived);
		return () => {
			// @ts-ignore
			socket.off('message', handleMessageReceived);
		};
	}, []);

	useEffectAsync(async () => {
		await handleLoadData();
	}, []);

	if (!count) {
		return <></>;
	}

	return isSpan ? (
		<span className={classes}>{count}</span>
	) : (
		<div className={classes}>{count}</div>
	);
};

export default NotificationCount;
